const filterMany = function(filterable, LEGAL_ENTITY, AREA, SEGMENT, SUBSEGMENT, COUNTER_PARTY, CONTRACT_TYPE, FEES_RANGES ){
    return filterable.ITEMS.filter(x => 
        (!x.FILTERS.LEGAL_ENTITY || x.FILTERS.LEGAL_ENTITY.includes(LEGAL_ENTITY)) &&
        (!x.FILTERS.AREA || x.FILTERS.AREA.includes(AREA)) &&
        (!x.FILTERS.SEGMENT || x.FILTERS.SEGMENT.includes(SEGMENT)) &&
        (!x.FILTERS.SUBSEGMENT || x.FILTERS.SUBSEGMENT.includes(SUBSEGMENT)) &&
        (!x.FILTERS.COUNTER_PARTY || x.FILTERS.COUNTER_PARTY.includes(COUNTER_PARTY)) &&
        (!x.FILTERS.CONTRACT_TYPE || x.FILTERS.CONTRACT_TYPE.includes(CONTRACT_TYPE)) &&
        (!x.FILTERS.FEES_RANGES || x.FILTERS.FEES_RANGES.includes(FEES_RANGES)) 
        )
}

const filterFirst = function(filterable, LEGAL_ENTITY, AREA, SEGMENT, SUBSEGMENT, COUNTER_PARTY, CONTRACT_TYPE, FEES_RANGES){
    let matching = filterMany(filterable, LEGAL_ENTITY, AREA, SEGMENT, SUBSEGMENT, COUNTER_PARTY, CONTRACT_TYPE, FEES_RANGES)
    if (matching.length > 0){
        return matching[0].VALUE;
    }
    else return filterable.DEFAULT
}

const ESignConfigModule = {
    namespaced: true,
    state: {
        esignConfig: null,
        configLoading: true,
    },
    actions: {
        SET_ESIGN_CONFIG({ state, commit }, esignConfig) {
            commit('SetESignConfig', esignConfig);
        },
    },
    mutations: {
        SetESignConfig: function (state, esignConfig) {
            state.esignConfig = esignConfig;
            state.configLoading = false;
        },
    },
    getters: {
        GetESignConfig: function (state) {
            try {
                return state.esignConfig;
            } catch (err) {
                return null;
            }
        },
        ESignConfigLoaded: function (state) {

            return state.esignConfig != null
        },
        ESignConfigLoading: function (state) {
            return state.configLoading
        },
        GetAreas: function (state) {
            return (legalentity) => {
                if (legalentity == null || legalentity == undefined) {
                    return state.esignConfig.LEGAL_ENTITY.LEGAL_ENTITIES
                        .filter(x => x != null)
                        .filter(x => !x.LEGAL_ENTITY_NAME.ISDELETED)
                        .map(x => x.AREAS.map(y => Object.assign({},y, { GROUP_NAME: x.LEGAL_ENTITY_NAME.NAME, GROUP_VALUE: x.LEGAL_ENTITY_NAME.VALUE })))
                        .filter(x => x != null)
                        .reduce(function (a, b) { return a.concat(b); }, [])
                }
                else {
                    return state.esignConfig.LEGAL_ENTITY.LEGAL_ENTITIES
                        .filter(x => x != null && x.LEGAL_ENTITY_NAME.VALUE == legalentity)
                        .filter(x => !x.LEGAL_ENTITY_NAME.ISDELETED)
                        .map(x => x.AREAS.map(y => Object.assign({},y, { GROUP_NAME: x.LEGAL_ENTITY_NAME.NAME, GROUP_VALUE: x.LEGAL_ENTITY_NAME.VALUE })))
                        .filter(x => x != null)
                        .reduce(function (a, b) { return a.concat(b); }, [])
                }
            }
        },
        GetApproversList: function (state, getters) {
            return getters.GetAreas().filter(x => x != null).map(function (x) {
                let list = []
                x.APPROVERS.forEach(function (item) {
                    list.push({
                        email: item.EMAIL,
                        name: item.NAME,
                        area: x.AREA_NAME.NAME,
                        areaval: x.AREA_NAME.VALUE,
                        legalentity: x.GROUP_NAME,
                        legalentityval: x.GROUP_VALUE,
                    })
                }
                )
                return list
            }).reduce(function (a, b) { return a.concat(b) })
        },
        GetAreaApprovers: function (state, getters) {
            return (area) => {
                if (area != undefined && area != null) {
                    return getters.GetAreas().filter(x => x != null).filter(x => x.AREA_NAME.VALUE == area).map(x => x.APPROVERS).filter(x => x != null).reduce(function (a, b) { return a.concat(b); }, [])
                }
                else {
                    return getters.GetAreas().filter(x => x != null).map(x => x.APPROVERS).filter(x => x != null).reduce(function (a, b) { return a.concat(b); }, [])
                }
            }
        },
        GetSegments: function (state, getters) {
            return (area) => {
                if (area != undefined && area != null) {
                    return getters.GetAreas()
                        .filter(x => x != null)
                        .filter(x => x.AREA_NAME.VALUE == area)
                        .map(x => x.SEGMENTS == null ? [] : x.SEGMENTS.map(y => Object.assign({}, y, { GROUP_NAME: x.AREA_NAME.NAME, GROUP_LE: x.GROUP_NAME, GROUP_VALUE: x.GROUP_VALUE + "_" + x.AREA_NAME.VALUE })))
                        .filter(x => x != null)
                        .reduce(function (a, b) { return a.concat(b); }, [])
                }
                else {
                    return getters.GetAreas()
                        .filter(x => x != null)
                        .map(x => x.SEGMENTS == null ? [] : x.SEGMENTS.map(y => Object.assign({}, y, { GROUP_NAME: x.AREA_NAME.NAME, GROUP_LE: x.GROUP_NAME, GROUP_VALUE: x.GROUP_VALUE + "_" + x.AREA_NAME.VALUE })))
                        .filter(x => x != null)
                        .reduce(function (a, b) { return a.concat(b); }, [])
                }
            }
        },
        GetSubSegments: function (state, getters) {
            return (area, segment) => {
                if (segment != undefined && segment != null) {
                    return getters.GetSegments(area).filter(x => x != null).filter(x => x.VALUE == segment).map(x => x.SUBSEGMENTS).filter(x => x != null).reduce(function (a, b) { return a.concat(b); }, [])
                }
                else {
                    return getters.GetSegments(area).filter(x => x != null).map(x => x.SUBSEGMENTS).filter(x => x != null).reduce(function (a, b) { return a.concat(b); }, [])
                }
            }
        },
        GetContractTypes: function (state) {

            return state.esignConfig.CONTRACT_TYPE
        },
        GetContractTypesByParams: function (state, getters) {
            return (counterparty, legalentity, area, segment) => {
                if (counterparty == null || counterparty == undefined || legalentity == null || legalentity == undefined) {
                    return []
                }
                var list = getters.GetContractTypes;
                let counter = getters.GetCounterParties.filter(x => x.VALUE == counterparty)[0].NAME.split(" ")[0].toUpperCase();

                //Filter by counterparty and
                list = list[counter + "_CONTRACT_TYPE"].filter(x => x != null && !x.ISDELETED)

                let legalEntityExcluded = null
                let areaExcluded = null
                let segmentExcluded = null

                    legalEntityExcluded = state.esignConfig.LEGAL_ENTITY.LEGAL_ENTITIES
                        .find(x => x != null && x.LEGAL_ENTITY_NAME.VALUE == legalentity).EXCLUDED_CONTRACT_TYPES

                    if (area != null && area != undefined) {

                        areaExcluded = getters.GetAreas()
                            .find(x => x.AREA_NAME.VALUE == area).EXCLUDED_CONTRACT_TYPES

                        if (segment != null && segment != undefined) {
                            segmentExcluded = getters.GetSegments(area)
                                .find(x => x.VALUE == segment).EXCLUDED_CONTRACT_TYPES
                        }
                    }

                list = list
                    .filter(x => legalEntityExcluded == null || legalEntityExcluded.indexOf(`${counterparty}_${x.VALUE}`) == -1)
                    .filter(x => areaExcluded == null || areaExcluded.indexOf(`${counterparty}_${x.VALUE}`) == -1)
                    .filter(x => segmentExcluded == null || segmentExcluded.indexOf(`${counterparty}_${x.VALUE}`) == -1)

                return list
            }
        },
        GetCounterParties: function (state) {

            return state.esignConfig.COUNTERPARTY
        },
        GetLegalEntity: function (state) {

            return state.esignConfig.LEGAL_ENTITY.LEGAL_ENTITIES
        },
        GetPageTitle: function (state) {

            return state.esignConfig.LEGAL_ENTITY.PAGE_TITLE
        },
        GetFeesRange: function (state) {
            return state.esignConfig.FEES.FEES_FILTER
        },
        GetFeesRangeByCounterParty: function (state, getters) {
            return (counterParty) => {
                if (counterParty != null && counterParty != undefined) {
                    let counter = getters.GetCounterParties.filter(x => x.VALUE == counterParty)[0].NAME.split(" ")[0].toUpperCase();
                    let type = counter + "_CONTRACT_TYPE";
                    return state.esignConfig.FEES[type]
                }
                else {
                    return []
                }
            }

        },
        GetApprovalProcess: function (state) {
            return state.esignConfig.APPROVAL_PROCESS
        },
        GetLegalComplianceCounsel: function (state) {
            return state.esignConfig.LEGAL_COMPLIANCE_COUNSEL
        },
        GetSigneesA: function (state, getters) {
            return (legalEntity, contractType, counterParty, feesRange) => {
                if (
                    legalEntity == null || legalEntity == undefined ||
                    contractType == null || contractType == undefined ||
                    counterParty == null || counterParty == undefined) {
                    return []
                }
                else {

                    let signees = state.esignConfig.SIGNEES.SIGNEE_ONE

                    let counter = getters.GetCounterParties.filter(x => x.VALUE == counterParty)[0].NAME.split(" ")[0].toUpperCase();
                    let type = counter + "_CONTRACT_TYPE";
                    let contractTypeGroup = getters.GetContractTypes[type].filter(x => x.VALUE == contractType)[0].GROUPTYPE

                    if (contractTypeGroup == 'NDA' || contractTypeGroup == 'INT' || contractTypeGroup == 'RIT') {
                        return signees.map(x => x.EMAIL_LIST).reduce(function (a, b) { return a.concat(b); }, []).map((item) => [item["EMAIL"], item]).map(x => x[1]).filter(function (v, i, s) {
                            return s.map(x => x.EMAIL).indexOf(v.EMAIL) == i
                        })
                    }
                    else {
                        signees = signees.filter(x => x.COUNTER_PARTY == null || x.COUNTER_PARTY.includes(counterParty))
                        signees = signees.filter(x => x.LEGAL_ENTITY == null || x.LEGAL_ENTITY.includes(legalEntity))
                        if (feesRange == null || feesRange == undefined) {
                            return []
                        }
                        else {
                            signees = signees.filter(x => x.FEES_RANGES == null || x.FEES_RANGES.includes(feesRange))
                        }
                    }
                    return signees.map(x => x.EMAIL_LIST).reduce(function (a, b) { return a.concat(b); }, []).map((item) => [item["EMAIL"], item]).map(x => x[1]).filter(function (v, i, s) {
                        return s.map(x => x.EMAIL).indexOf(v.EMAIL) == i
                    })
                }
            }
        },
        GetSigneesB: function (state, getters) {
            return (legalEntity, contractType, counterParty, feesRange) => {
                if (
                    legalEntity == null || legalEntity == undefined ||
                    contractType == null || contractType == undefined ||
                    counterParty == null || counterParty == undefined ||
                    feesRange == null || feesRange == undefined
                ) {
                    return []
                }
                else {

                    let signees = state.esignConfig.SIGNEES.SIGNEE_TWO
                    signees = signees.filter(x => x.COUNTER_PARTY == null || x.COUNTER_PARTY.includes(counterParty))
                    signees = signees.filter(x => x.LEGAL_ENTITY == null || x.LEGAL_ENTITY.includes(legalEntity))
                    signees = signees.filter(x => x.FEES_RANGES == null || x.FEES_RANGES.includes(feesRange))

                    return signees.map(x => x.EMAIL_LIST).reduce(function (a, b) { return a.concat(b); }, []).map((item) => [item["EMAIL"], item]).map(x => x[1]).filter(function (v, i, s) {
                        return s.map(x => x.EMAIL).indexOf(v.EMAIL) == i
                    })
                }
            }
        },
        GetCounterPartySigneeConfig: function (state, getters) {
            return (filterableValues) => {
                return filterFirst(state.esignConfig.SIGNEES.SIGNEE_COUNTER_PARTY, filterableValues.LEGAL_ENTITY, filterableValues.AREA, filterableValues.SEGMENT, filterableValues.SUBSEGMENT, filterableValues.COUNTER_PARTY, filterableValues.CONTRACT_TYPE, filterableValues.FEES_RANGES)
            }
        },
        GetLiabilityCapOptions: function (state) {
            return (filterableValues) => {
                return filterFirst(state.esignConfig.LIABILITY_CAP_OPTIONS, filterableValues.LEGAL_ENTITY, filterableValues.AREA, filterableValues.SEGMENT, filterableValues.SUBSEGMENT, filterableValues.COUNTER_PARTY, filterableValues.CONTRACT_TYPE, filterableValues.FEES_RANGES)
            } 
        },
        GetDueDiligence: function (state, getters) {
            return (counterParty) => {
                if (counterParty != null && counterParty != undefined) {
                    let counter = getters.GetCounterParties.filter(x => x.VALUE == counterParty)[0].NAME.split(" ")[0].toUpperCase();
                    return state.esignConfig.DUE_DILIGENCE[counter]
                }
                else return {
                    BODY: "",
                    CHECKS: [],
                    OPTIONS: [],
                    TITLE: ""
                }
            }
        },

        GetFormTags: function(state, getters){
            return (filterableValues) => {
                return filterFirst(state.esignConfig.LEGAL_ENTITY.FORM_TAGS, filterableValues.LEGAL_ENTITY, filterableValues.AREA, filterableValues.SEGMENT, filterableValues.SUBSEGMENT, filterableValues.COUNTER_PARTY, filterableValues.CONTRACT_TYPE, filterableValues.FEES_RANGES)
            } 

        }

    }
}
export default ESignConfigModule;